import React from 'react';
import PropTypes from 'prop-types';
import micIcon from '@lifesize/ux-assets/vectors/svgIcons/mic.svg';
import classes from './AudioButton.module.scss';
import AudioMonitor from '../../utils/AudioMonitor';

class LevelledIcon extends React.Component {
  constructor(props) {
    super(props);
    this.state = { micLevel: 0 };
  }

  componentDidMount() {
    this.monitor = new AudioMonitor(value => this.onAudioMonitorUpdate(value));
    this.connectAudioMonitor();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.microphoneDeviceId !== this.props.microphoneDeviceId) {
      this.connectAudioMonitor();
    }
  }

  componentWillUnmount() {
    this.monitor.destroy();
  }

  onAudioMonitorUpdate(value) {
    const micLevel = (value * 100).toFixed(0);
    if (this.state.micLevel !== micLevel) {
      this.setState({ micLevel });
    }
  }

  getMicStyle = () => {
    return {
      backgroundPosition: `left 0px top ${this.state.micLevel || 0}%`,
      WebkitMaskImage: `url(${micIcon})`
    }
  }

  connectAudioMonitor() {
    if (this.props.microphoneDeviceId) {
      this.monitor.connect(this.props.microphoneDeviceId);
    }
    else {
      this.monitor.disconnect();
    }
  }

  render() {
    return (
      <div className={`${classes.activeMic} ${this.props.iconClass}`} style={this.getMicStyle()} />
    );
  }
}

LevelledIcon.propTypes = {
  iconClass: PropTypes.string,
  isMinimized: PropTypes.bool,
  microphoneDeviceId: PropTypes.string
};

export default LevelledIcon;
